import React, { Fragment } from 'react';
import NavbarContainer from 'shared/containers/NavbarContainer';
import RegisterContainer from 'bundles/LoginRegister/containers/RegisterContainer';

const RegisterScene = (props) => {
    return (
        <Fragment>
            <NavbarContainer />
            <RegisterContainer {...props} />
        </Fragment>
    );
};

export default RegisterScene;
